import React, { useEffect } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchPermissions } from './api';
import { useAtomValue, useSetAtom } from 'jotai';
import { permissionAtom } from '~/store/permission';
import { restaurantAtom } from '~/store/restaurant';

const PermissionProvider = () => {
  const restaurant = useAtomValue(restaurantAtom);
  const { data } = useSuspenseQuery({
    queryKey: ['permissions', restaurant?.restaurantId],
    queryFn: async () => {
      if (!restaurant?.restaurantId) return [];
      const { permissions } = await fetchPermissions();
      return permissions;
    },
    gcTime: Infinity,
    staleTime: Infinity,
  });
  const setPermission = useSetAtom(permissionAtom);

  useEffect(() => {
    setPermission(data);
  }, [data]);

  return null;
};

export default PermissionProvider;
